import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';

@Component({
  selector: 'app-produk-add-level',
  templateUrl: './produk-add-level.component.html',
  styleUrls: ['./produk-add-level.component.css']
})
export class ProdukAddLevelComponent implements OnInit {
  @Output() goNext = new EventEmitter<void>();
  @Output() goBack = new EventEmitter<void>();

  load: boolean = false;
  dataUser: any;
  du: any;
  levelingApprovals: any[] = [];

 constructor(
     public api: ApiService,
     public util: UtilService,
     public activatedRoute: ActivatedRoute,
     public router: Router,
   ) {
 
   }

  ngOnInit(): void {
    this.getUserApproval();
    this.addlevel();
  }

    getUserApproval() {
    this.load = true;
    this.api.get('data/master/users-client')
      .subscribe((data) => {
        this.dataUser = data;
        if (this.dataUser.error == 0) {
          this.load = false;
          this.du = this.dataUser.data;
        } else {
          this.load = false;
          this.util.showToast(this.dataUser.message, 'danger', 'bottom');
        }
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error)
      });
  }

  addlevel() {
    this.levelingApprovals.push({
      submission_loan_start: null,
      submission_loan_end: null,
      final_approval: '',
      approval_1: '',
      approval_2: ''
    });
  }

  removeLevel(index: number) {
    if (this.levelingApprovals.length > 1) {
      this.levelingApprovals.splice(index, 1);
    }
  }

  back() {
    this.goBack.emit();
  }

  next() {
    this.goNext.emit();
  }
}
